



























import authMixin from '@/mixins/auth';
import mixins from '@/utils/mixins';

export default mixins(authMixin).extend({
  name: 'BankOptionsButton'
});
